import { ModuleConfig } from '@/core/module';
import { profileManagementRoutes } from './routes';

export const ProfileManagementModule: ModuleConfig = {
    name: 'admin-profile-management',
    routes: profileManagementRoutes,
    initialize: () => {
        console.log('Admin Profile Management module initialized');
    }
};
